/**
 * @memberOf app.core
 * @name CoreController
 * @ngdoc controller
 */
export default class CoreController {
  constructor($scope, Idle, $mdDialog, LoginService, $state, Title) {

    /**
     * @memberOf CoreController
     * @type {service}
     * @description Instance of $scope
     */
    this.$scope = $scope;

    /**
     * @memberOf CoreController
     * @type {service}
     * @description Instance of Ng-Idle 'Idle' service
     */
    this.Idle = Idle;

    /**
     * @memberOf CoreController
     * @type {service}
     * @description Instance of Angular Material's $mdDialog service
     */
    this.$mdDialog = $mdDialog;

    /**
     * @memberOf CoreController
     * @type {LoginService}
     * @description Instance of LoginService
     */
    this.loginService = LoginService;

    /**
     * @memberOf CoreController
     * @type {service}
     * @description Instance of ui-router's $state service
     */
    this.$state = $state;

    /**
     * @memberOf CoreController
     * @type {service}
     * @description Instance of Ng-Idle 'Title' service, keeps track of title of page during Idle events
     */
    this.Title = Title;

    this.startListeners();
  }

  /**
   * @memberOf CoreController
   * @param {event} event IdleStart event
   * @description Opens an alert dialog that shows the current time until the user's session expires.
   */
  openAlert(event) {
    this.$mdDialog.show({
      parent: angular.element(document.body),
      templateUrl: 'partials/alert.html',
      clickOutsideToClose: false,
      scope: this.$scope,
      targetEvent: event,
      ariaLabel: 'Alert Dialog',
      preserveScope: true
    });
  }

  /**
   * @memberOf CoreController
   * @description Starts listeners for Idle events on the scope for this controller
   */
  startListeners() {
    this.$scope.$on('IdleStart', (event) => {
      this.openAlert(event);
    });

    this.$scope.$on('IdleWarn', (event, countdown) => {
      this.convertCountdown(countdown);
    });

    this.$scope.$on('IdleTimeout', () => {
      this.logout();
    });
  }

  /**
   * @memberOf CoreController
   * @param {int} countdown number in seconds until sessions expires
   * @description Converts seconds to minutes and seconds if seconds > 60.
   */
  convertCountdown(countdown) {
    this.countdown = {};
    if (countdown > 60) {
      this.countdown.minutes = Math.floor(countdown / 60);
      this.countdown.seconds = countdown - (this.countdown.minutes * 60);
      if (this.countdown.minutes <= 1) {
        this.minutes = "minute";
      } else {
        this.minutes = "minutes";
      }
    } else {
      this.countdown.seconds = countdown;
      this.countdown.minutes = 0;
      this.units = "seconds";
    }
  }

  /**
   * @memberOf CoreController
   * @description User has decided to continue session. Restart idle watch and hide dialog.
   */
  continue() {
    this.Idle.watch();
    this.$mdDialog.hide();
  }

  /**
   * @memberOf CoreController
   * @description Logs out user by calling LoginService.logout, restores title, changes state to login and hides alert dialog
   */
  logout() {
    this.$mdDialog.hide();
    this.loginService.logout();
    this.Title.restore();
    this.$state.go('login');
  }
}

CoreController.$inject = ['$scope', 'Idle', '$mdDialog', 'LoginService', '$state', 'Title'];



// WEBPACK FOOTER //
// ./src/client/app/core/core.controller.js